// File: src/components/about/Innovation.js

import React from 'react';
import styles from './Innovation.module.css';
import ScrollAnimation from '../common/ScrollAnimation';
import { cn } from '../../utils/helpers';

const INNOVATION_STATS = [
  { id: 'castings', value: '180 kg', label: 'Of worm castings produced per tonne of organic waste processed' },
  { id: 'params',  value: '9',      label: 'Critical operational parameters tracked in real time, 24/7' },
  {
    id: 'carbon',
    value: '1:1',
    label: 'Certified carbon credit generated per tonne processed',
    disclaimer: 'Disclaimer: The CO₂e claim assumes a 1:1 ratio, subject to jurisdiction and current regulatory practices.',
  },
];

const INNOVATION_POINTS = [
  {
    id: 'resource',
    title: 'Waste as a Resource',
    body: 'GreenScience\'s technology represents a world-first advancement in how the millions of tonnes of organic waste generated daily in Canada are managed. Rather than viewing organic waste as a disposal challenge, the company treats it as an underutilized natural resource.',
  },
  {
    id: 'biological',
    title: 'A Highly Efficient Biological Process',
    body: 'The system creates a controlled environment where a cluster of earthworms naturally process organic waste. Through this biological process, every tonne of organic waste produces approximately 180 kilograms of premium worm castings — a valuable organic soil amendment harvested daily.',
  },
  {
    id: 'carbon',
    title: 'Carbon Credit Generation',
    body: 'In addition to producing nutrient-rich soil products, the process is certified to generate one tonne of carbon credits for every tonne of organic waste processed — creating an additional environmental and economic benefit through tradable carbon offsets.',
  },
  {
    id: 'monitoring',
    title: 'Advanced Remote Monitoring',
    body: 'Each unit continuously tracks 9 critical operational parameters in real time, 24/7, using an array of precision sensors. The system can be monitored and managed remotely through mobile devices, allowing operators to identify and address issues instantly whenever sensors detect irregularities.',
  },
];

function Innovation() {
  return (
    <section className={styles.section}>
      <div className="site-container">

        {/* Header */}
        <ScrollAnimation className={styles.header}>
          <p className={styles.eyebrow}>Innovation</p>
          <h2 className={styles.heading}>A World-First Advancement</h2>
          <p className={styles.subheading}>
            The GS Digester doesn't just process organic waste more efficiently —
            it reframes what organic waste is, and what it can become.
          </p>
        </ScrollAnimation>

        {/* Stat row */}
        <ScrollAnimation className={styles.statRow}>
          {INNOVATION_STATS.map((stat, i) => (
            <div key={stat.id} className={cn(styles.statItem, i < INNOVATION_STATS.length - 1 && styles.statItemBorder)}>
              <span className={styles.statValue}>{stat.value}</span>
              <span className={styles.statLabel}>{stat.label}</span>
              {stat.disclaimer && (
                <span className={styles.statDisclaimer}>{stat.disclaimer}</span>
              )}
            </div>
          ))}
        </ScrollAnimation>

        {/* Points grid */}
        <div className={styles.pointsGrid}>
          {INNOVATION_POINTS.map((point, i) => (
            <ScrollAnimation key={point.id} delay={i * 100} className={styles.pointWrap}>
              <div className={styles.point}>
                <div className={styles.pointNumber}>0{i + 1}</div>
                <h3 className={styles.pointTitle}>{point.title}</h3>
                <p className={styles.pointBody}>{point.body}</p>
              </div>
            </ScrollAnimation>
          ))}
        </div>

      </div>
    </section>
  );
}

export default Innovation;